import { createFileRoute, redirect } from '@tanstack/react-router'

// Bare Delta has no pane of its own — land on the first sub-tab.
export const Route = createFileRoute('/_app/dev-resources/transitions/one/item/delta/')({
  beforeLoad: () => {
    throw redirect({ to: '/dev-resources/transitions/one/item/delta/x' })
  },
})
